<template>
  <PageTemplate>
    <h1>Facilities/Sites</h1>
    <v-card title="Facilities">
      <v-table
        :table="table"
        :action-msg="table.actionMsg"
        @updateRowData="updateRowData"
      />
    </v-card>
    <v-modal
      v-if="showEditModal"
      @close="closeEditModal"
    >
      <template #header>
        Update Contact Details
      </template>
      <template v-for="col in editData.editableCols">
        {{ col.key.toUpperCase() }}
        <v-input
          :key="col.key"
          :name="col.key"
          :value="col.value"
          @input="changeColValue"
        />
      </template>
      <template #footer>
        <v-alert
          v-if="showSuccess"
          icon="notification"
        >
          {{ showSuccessMsg }}
        </v-alert>
        <v-alert
          v-if="showError"
          icon="notification"
        >
          {{ showErrorMsg }}
        </v-alert>
        <v-button-group is-right>
          <v-button
            v-if="dataIsChanged"
            size="lg"
            has-min-width
            @click="commitUpdateData"
          >
            Finish
          </v-button>
          <v-button
            color="secondary"
            size="lg"
            has-min-width
            @click="closeEditModal"
          >
            Close
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "../templates/Page/index.vue";
  import Card from "@/molecules/Card";
  import Modal from "@/atoms/Modal";
  import Table from "@/molecules/Table";
  import Button from "@/atoms/Button";
  import Input from "@/atoms/Input";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Alert from "@/atoms/Alert";
  import {columnFilter, columnSort, stateList, buildBreadCrumb} from "@/common/tableFunctions"
  import routes from "@/common/routes"
  import {GET_FACILITIES, UPDATE_FACILITY} from "@/store/actions.type";

  export default {
    name: "Facilities",
    components: {
      "v-table": Table,
      "v-alert": Alert,
      "v-card": Card,
      "v-modal": Modal,
      "v-input": Input,
      "v-button": Button,
      "v-button-group": ButtonGroup,
      PageTemplate,
    },
    data() {
      return {
        table: {
          columns: [
            {
              label: 'Facility Name',
              field: 'facility_name',
              link: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Facility Name',
                filterFn: columnFilter,
              },
            },
            {
              label: 'Facility Number',
              field: 'facility_number',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Facility NO.',
                filterFn: columnFilter,
              },
            },
            {
              label: 'Site Name',
              field: 'site_name',
              link: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Search name',
                filterFn: columnFilter,
              },
            },
            {
              label: 'Site Number',
              field: 'site_number',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Site ID',
                filterFn: columnFilter,
              },
            },
            {
              label: 'Status',
              field: 'site_status',
              badge: true,
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: [],
                filterFn: columnFilter,
              },
            },
            {
              label: 'State',
              field: 'state',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'All',
                filterDropdownItems: stateList,
                filterFn: columnFilter,
              },
            },
            {
              label: 'Suburb/City',
              field: 'suburb',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Search suburb',
                filterFn: columnFilter,
              }
            },
            {
              label: 'Actions',
              field: 'actions',
              actions: 'edit',
              sortable: false,
              thClass: 'shrink-cell',
              tdClass: 'no-wrap',
            }
          ],
          rows: [],
          editableCols: {
            key: 'id',
            cols: ['suburb', 'state']
          },
          totalRecords: 0
        },
        breadcrumbs: [],
        showEditModal: false,
        openEditModal: false,
        editData: {},
        editedData: {},
        dataIsChanged: false,
        actionStatus: false,
        showSuccess: false,
        showError: false,
        showSuccessMsg: 'Action successfully!!',
        showErrorMsg: null,
        actionMsg: {}
      };
    },
    watch: {
      actionMsg() {
        if (this.actionMsg.success) {
          this.actionStatus = true;
          this.showSuccess = true;
          this.showError = false;
          this.dataIsChanged = false;
        }
        else {
          this.showError = true;
          this.showSuccess = false;
          let errors = this.actionMsg.data;
          let errorMsg = '';

          errorMsg = Object.keys(errors).map(function (key) {
            return errorMsg.concat(key, ':', errors[key][0], ';')
          });
          this.showErrorMsg = 'Action fail: ' + errorMsg
        }
      }
    },
    created() {
      this.showSuccess = false;
      this.showError = false;
      this.showEditModal = false;
      this.actionStatus = false;
    },
    mounted() {
      this.getFacilities();
      this.updateBreadCrumb();
    },
    methods: {
      updateBreadCrumb: function (fn) {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Facilities/Sites'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getFacilities: function (params) {
        this.$store.dispatch(GET_FACILITIES, {params}).then(response => {
          let list = response;
          this.table.rows = this.formatFacilities(list);

          //filter unique status
          const arr = this.table.rows.map(i => i.status);
          this.table.columns[4].filterOptions.filterDropdownItems = Array.from([...new Set(arr.filter(
            function (el) {
              return el != null;
            }
          ))]);

          // //filter unique state
          const arr2 = this.table.rows.map(i => i.state.value);
          this.table.columns[5].filterOptions.filterDropdownItems = Array.from([...new Set(arr2.filter(
            function (el) {
              return el != '-';
            }
          ))]);

          this.table.totalRecords = list.length;
        });
      },
      updateRowData: function (params) {
        this.showEditModal = true;

        let tempObj = params;
        let cols = this.table.editableCols;
        let selectedRow = {};
        let array = [];
        Object.keys(tempObj).map(function (key, index) {
          if (key == cols.key) {
            selectedRow.key = tempObj[key];
          }
          if (cols.cols.indexOf(key) != -1) {
            typeof(tempObj[key]) == 'string' ? array.push({'key': key, 'value': tempObj[key]}) : array.push({
              'key': key,
              'value': tempObj[key].value
            });
          }
        });
        selectedRow.editableCols = array;
        this.editData = selectedRow;
      },
      commitUpdateData: function () {
        let data = {};
        let dataParams = {};
        let params = this.editedData;
        data.facility_id = params.key;
        Object.keys(params.editableCols).map(function (key, index) {
          let k = params.editableCols[key].key;
          let val = params.editableCols[key].value;
          dataParams[k] = val;
        });
        data.params = dataParams;
        this.$store.dispatch(UPDATE_FACILITY, {data})
          .then(response => {
            this.actionMsg = response;
          })
          .catch((err) => {
            this.actionMsg = err;
          });
      },
      changeColValue: function (data) {
        let temp = this.editData;
        temp.editableCols.map(function (col) {
          if (data.id == col.key) {
            col.value = data.input;
          }
        });
        this.editedData = temp;
        this.dataIsChanged = true;
      },
      closeEditModal: function () {
        this.showEditModal = false;
        this.showSuccess = false;
        this.showError = false;

        if (this.actionStatus === true) {
          document.location.reload();
        }
      },
      formatFacilities: function (list) {
        let allSites = [];
        list.forEach((site) => {

          // Facility Variables
          let facility_name = {};
          let facility_number = {};
          facility_number.value = site.facility.facility_number;
          facility_name.value = site.facility.name;
          facility_name.link = 'facility/' + site.facility.id;

          let site_name = {};
          let status = {};
          let site_number = {};
          let state = {};
          let suburb = {};
          let contact_phone = null;
          let contact_name = null;

          site.facility_name = site.facility.name;
          site.facility_number = site.facility.facility_number;

          site_number.value = site.site_number;
          site_name.value = site.name;
          site_name.link = 'site/' + site.id;
          state.value = site.state;
          suburb.value = site.suburb;
          status.value = site.status;
          status.type = site.status == 'In Progress' ? 'accent' : null;

          site.facility_number = facility_number;
          site.facility_name = facility_name;
          site.site_number = site_number;
          site.site_name = site_name;
          site.site_status = status;
          site.suburb = suburb;
          site.state = state;
          site.contact_phone = '';
            site.contact_name = '';
          let temp = JSON.parse(site.contacts);
          if(temp && temp.contacts.length > 0) {
            site.contact_phone = temp.contacts[0].phone;
            site.contact_name = temp.contacts[0].name;
          }

          allSites.push(site)

        });

        return allSites;
      }
    }
  }
</script>

